import type MiniUser from '../../../../../types/MiniUser';
import { AssessmentStatus, AssessmentType, type Answer } from '../types';

export const ASSESSMENT_TYPES: Record<AssessmentType, AssessmentType> = {
    SELF_ASSESSMENT: AssessmentType.SELF_ASSESSMENT,
    ASSESSMENT: AssessmentType.ASSESSMENT,
    CONTRIBUTOR_ASSESSMENT: AssessmentType.CONTRIBUTOR_ASSESSMENT,
};

export const QUESTION_TYPES: Record<Answer['type'], Answer['type']> = {
    GRAPH_RATING: 'GRAPH_RATING',
    RATING: 'RATING', // overall rating
    SECONDARY_RATING: 'SECONDARY_RATING', // overall rating
    TEXT: 'TEXT',
    TEXT_WITH_RATING: 'TEXT_WITH_RATING',
    SCALES: 'SCALES',
    HEADING: 'HEADING',
    SLIDER: 'SLIDER',
    CHECKBOXES: 'CHECKBOXES',
    DROPDOWN: 'DROPDOWN',
};

export const ASSESSMENT_STATUS: Record<AssessmentStatus, AssessmentStatus> = {
    NOT_STARTED: AssessmentStatus.NOT_STARTED,
    STARTED: AssessmentStatus.STARTED,
    WRITTEN: AssessmentStatus.WRITTEN,
    SHARED: AssessmentStatus.SHARED,
    SIGNED: AssessmentStatus.SIGNED,
};

export const REVIEW_STATUS: Record<AssessmentStatus, string> = {
    NOT_STARTED: 'Not started',
    STARTED: 'Started',
    WRITTEN: 'Written',
    SHARED: 'Shared',
    SIGNED: 'Signed',
};

export const ACTION_TYPES = {
    SHARING: 'SHARING',
    SIGNING: 'SIGNING',
    HIDING: 'HIDING',
};

export const REASONS_NOT_SIGNABLE = {
    ALREADY_SIGNED: 'ALREADY_SIGNED',
    ASSESSMENT_NOT_SHARED: 'ASSESSMENT_NOT_SHARED',
    SELF_ASSESSMENT_NOT_SHARED: 'SELF_ASSESSMENT_NOT_SHARED',
    INDIRECT_MANAGERS_CANNOT_SIGN: 'INDIRECT_MANAGERS_CANNOT_SIGN',
    EXCEEDED_CHARACTER_LIMIT: 'EXCEEDED_CHARACTER_LIMIT',
};

export const REASONS_NOT_SHAREABLE = {
    INDIRECT_MANAGERS_CANNOT_SHARE: 'INDIRECT_MANAGERS_CANNOT_SHARE',
    BEFORE_SHARE_FROM_DATE: 'BEFORE_SHARE_FROM_DATE',
    NOT_MAIN_REVIEWER_AND_NO_SPECIAL_PERMISSION: 'NOT_MAIN_REVIEWER_AND_NO_SPECIAL_PERMISSION',
    EXCEEDED_CHARACTER_LIMIT: 'EXCEEDED_CHARACTER_LIMIT',
};

export const anonymousUser: MiniUser = {
    id: 'anonymous--id',
    name: 'Anonymous',
    firstName: 'Anonymous',
    lastName: '',
    logo: '/images/characters/avatar-anonymous.svg',
    gender: 'unspecified',
    isActive: true,
    isPlaceholder: true,
    managerId: null,
};
